import React from 'react';
import { Link } from "react-router-dom";
import {getExperimentExport} from '../services/ExperimentService';
import {copyExperiment} from '../services/ExperimentService';
import {getExperimentDetail} from '../services/ExperimentService';
import {changeExperimentState} from '../services/ExperimentService';
import PartDetail from './components/PartDetail';

class ExperimentView extends React.Component {
    constructor(props) {
        super(props);
        var baseUrl = window.location.href;
        this.state = {
            id: baseUrl.substring(baseUrl.lastIndexOf('/') + 1),
            jwtToken: props.jwtToken,
            experimentData: [],
            timeoutPeriod: "",
            accessToken: "",
            badgesStyles: [],
            stateTransfer: []
        };
        this.updateData = this.updateData.bind(this);
        this.setStateSettings = this.setStateSettings.bind(this);
        this.toggleRawData = this.toggleRawData.bind(this);
        this.handleStateChange = this.handleStateChange.bind(this);
        this.handleExport = this.handleExport.bind(this);
        this.handleCopy = this.handleCopy.bind(this);
    }

    handleCopy = (e) => {
        copyExperiment(this.state.jwtToken, this.state.id)
        .then(response =>  {
            if (response.ok) {
                response.json().then( experimentCopyDto => {
                    window.alert("Copy created successfully.\nNew experiment name: '" + experimentCopyDto.name + "'");
                });
            } else {
                window.alert("Copy could not be created.");
            }
        });
    }

    handleExport = (e) => {
        getExperimentExport(this.state.jwtToken, this.state.id)
        .then(response =>  {
            if (response.ok) {
                response.blob().then( fileData => {
                    var downloadUrl = window.URL.createObjectURL(fileData),
                    dummyLink = document.createElement("a");
                    dummyLink.href = downloadUrl;
                    dummyLink.download = "experiment-export.json";
                    dummyLink.click();
                    window.URL.revokeObjectURL(downloadUrl);
                });
            } else {
                window.alert("Download fail.");
            }
        });
    }

    handleStateChange = (e) => {
        if (e.target.id === "editBadge" && this.state.stateTransfer.edit) {
            changeExperimentState(this.state.jwtToken, this.state.id, "EDIT")
            .then(response =>  {
                if (response.ok) {
                    window.alert("State transfer successful.");
                    this.updateData();
                } else {
                    window.alert("State could not be changed for this experiment.");
                }
            });
        }
        else if (e.target.id === "debugBadge" && this.state.stateTransfer.debug) {
            changeExperimentState(this.state.jwtToken, this.state.id, "DEBUG")
            .then(response =>  {
                if (response.ok) {
                    window.alert("State transfer successful.");
                    this.updateData();
                } else {
                    window.alert("State could not be changed for this experiment.");
                }
            });
        }
        else if (e.target.id === "openBadge" && this.state.stateTransfer.open) {
            changeExperimentState(this.state.jwtToken, this.state.id, "OPEN")
            .then(response =>  {
                if (response.ok) {
                    window.alert("State transfer successful.");
                    this.updateData();
                } else {
                    window.alert("State could not be changed for this experiment.");
                }
            });
        }
        else if (e.target.id === "closedBadge" && this.state.stateTransfer.closed) {
            changeExperimentState(this.state.jwtToken, this.state.id, "CLOSED")
            .then(response =>  {
                if (response.ok) {
                    window.alert("State transfer successful.");
                    this.updateData();
                } else {
                    window.alert("State could not be changed for this experiment.");
                }
            });
        }
    }

    setStateSettings(){
        // if user does not have right to change state, disable transitions and only highlight current state
        if (!this.state.experimentData.editable) {
            switch(this.state.experimentData.state) {
              case "EDIT":
                this.setState({badgesStyles: {edit: "#337ab7", debug: "lightgrey", open: "lightgrey", closed: "lightgrey"}});
                break;
              case "DEBUG":
                this.setState({badgesStyles: {edit: "lightgrey", debug: "#337ab7", open: "lightgrey", closed: "lightgrey"}});
                break;
              case "OPEN":
                this.setState({badgesStyles: {edit: "lightgrey", debug: "lightgrey", open: "#337ab7", closed: "lightgrey"}});
                break;
              case "CLOSED":
                this.setState({badgesStyles: {edit: "lightgrey", debug: "lightgrey", open: "lightgrey", closed: "#337ab7"}});
                break;
              default:
                console.log("Wrong state supplied");
            }

            this.setState({stateTransfer: {edit: false, debug: false, open: false, closed: false} });
            return;
        }

        // else render normal state button styles and enable transitions
        switch(this.state.experimentData.state) {
          case "EDIT":
            this.setState({badgesStyles: {edit: "#337ab7", debug: "#777", open: "lightgrey", closed: "lightgrey"},
                           stateTransfer: {edit: false, debug: true, open: false, closed: false} });
            break;
          case "DEBUG":
            this.setState({badgesStyles: {edit: "#777", debug: "#337ab7", open: "#777", closed: "lightgrey"},
                           stateTransfer: {edit: true, debug: false, open: true, closed: false} });
            break;
          case "OPEN":
            this.setState({badgesStyles: {edit: "lightgrey", debug: "lightgrey", open: "#337ab7", closed: "#777"},
                            stateTransfer: {edit: false, debug: false, open: false, closed: true} });
            break;
          case "CLOSED":
            this.setState({badgesStyles: {edit: "lightgrey", debug: "lightgrey", open: "lightgrey", closed: "#337ab7"},
                            stateTransfer: {edit: false, debug: false, open: false, closed: false} });
            break;
          default:
            console.log("Wrong state supplied");
        }
    }

    toggleRawData(){
        if (this.state.hideRawData){
            this.setState({hideRawData: false});
        }  else {
            this.setState({hideRawData: true});
        }
    }

    updateData(){
        getExperimentDetail(this.state.jwtToken, this.state.id)
            .then(response =>
                {
                    this.setState({experimentData: response,
                                   accessToken: response.accessToken,
                                   timeoutPeriod: response.timeoutPeriod});
                    this.setStateSettings();
                }
            );
    }

    componentDidMount() {
        this.updateData();
    }

    render() {
        var renderedParts = [];
        if (typeof this.state.experimentData.parts !==  "undefined"){
            for (var i = 0; i < this.state.experimentData.parts.length; i++) {
                renderedParts.push( <PartDetail key={i} partIndex={i} data={this.state.experimentData.parts[i]}/> );
            }
        }

        var currentStateTitle = "Current state of the experiment";
        var changeableStateTitle = "Changes the state to ";
        var nonChangeableStateTitle = "This state transition is not available for the current state and rights";

    return (
    <>
        <script src="https://d3js.org/d3.v7.min.js"></script>
        <div className="row" style={{marginLeft: "4%", marginRight: "4%"}}>
            <h1>
                <Link to="/">
                    <span title="Return to experiment listing">All experiments/</span>
                </Link>
                { (typeof this.state.experimentData.shared !== "undefined" && this.state.experimentData.shared) ?
                    <Link to="/shared">
                        <span title="Return to shared experiment listing">shared/</span>
                    </Link> : <></>
                }
                {this.state.experimentData.name}
            </h1>
            <div style={{fontSize: "20px", paddingTop: "20px", paddingBottom: "20px"}}>
                <span  style={{display: "inline-block",width: "100px", padding:"10px",
                    backgroundColor:this.state.badgesStyles.edit}}
                    className="label" id="editBadge" onClick={this.handleStateChange}
                    title={this.state.experimentData.state === "EDIT" ? currentStateTitle :
                        (this.state.stateTransfer.edit ? changeableStateTitle + "EDIT": nonChangeableStateTitle)}>EDIT</span>
                <span style={{display: "inline-block",width: "100px", padding:"10px",
                    backgroundColor:this.state.badgesStyles.debug}}
                    className="label" id="debugBadge" onClick={this.handleStateChange}
                    title={this.state.experimentData.state === "DEBUG" ? currentStateTitle :
                    (this.state.stateTransfer.debug ? changeableStateTitle + "DEBUG": nonChangeableStateTitle)}>DEBUG</span>
                <span style={{display: "inline-block",width: "100px", padding:"10px",
                    backgroundColor:this.state.badgesStyles.open}}
                    className="label" id="openBadge" onClick={this.handleStateChange}
                    title={this.state.experimentData.state === "OPEN" ? currentStateTitle :
                    (this.state.stateTransfer.open ? changeableStateTitle + "OPEN": nonChangeableStateTitle)}>OPEN</span>
                <span style={{display: "inline-block",width: "100px", padding:"10px",
                    backgroundColor:this.state.badgesStyles.closed}}
                    className="label" id="closedBadge" onClick={this.handleStateChange}
                    title={this.state.experimentData.state === "CLOSED" ? currentStateTitle :
                    (this.state.stateTransfer.closed ? changeableStateTitle + "CLOSED": nonChangeableStateTitle)}>CLOSED</span>

                <Link to={"#"} style={{float:"right", marginLeft:"10px"}}>
                    <span title="Export experiment" onClick={this.handleExport} className="glyphicon glyphicon-download-alt" />
                </Link>
                <Link to={"#"} style={{float:"right", marginLeft:"10px"}}>
                    <span title="Create copy of this experiment" onClick={this.handleCopy} className="glyphicon glyphicon-duplicate" />
                </Link>
                <label style={{float:"right", fontSize:"16px"}}>Other actions:</label>
            </div>

            <p className="small">{this.state.experimentData.description}</p>

            <div style={{width: "40%", marginTop: "20px"}} className="form-group">
                <label>Access token</label>
                <input className="form-control" id="experimentAccessToken" type="text"
                    value={this.state.accessToken} readOnly/>
            </div>

            <div style={{width: "40%", marginTop: "20px"}} className="form-group">
                <label>Timeout period [minutes]</label>
                <input className="form-control" id="experimentTimeoutMinutes" type="text"
                    value={this.state.timeoutPeriod} readOnly/>
            </div>

            <h2 style={{marginTop: "40px"}}>Parts</h2>
            <hr style={{marginTop:"0px"}}/>
            <div style={{display: "flex", flexWrap: "wrap"}}>{renderedParts}</div>

            <div className="alert alert-warning" style={{textAlign: "center" }} hidden={renderedParts.length !== 0}>
              <strong>No part data available.</strong>
            </div>
        </div>
    </>
    );
    }
}

export default ExperimentView;
